import React from "react";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";

import css from "./MenuCategoriesUpdateCategoryModal.module.css";
import { menuCategoriesService } from "../../../../services/settings-services";
import { menuCategoriesActions } from "../../../../store/slices/settings-slices";
import { getConfig } from "../../../../config";

const MenuCategoriesUpdateCategoryModal = ({
  setIsOpenUpdate,
  menuCategory,
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { cityCode } = getConfig();
  const {
    id,
    name: { en, ru, ge, ar },
  } = menuCategory;

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ defaultValues: { en: en, ru: ru, ge: ge, ar: ar } });

  const submitHandler = async (data) => {
    try {
      await menuCategoriesService.updateById(id, { name: data });
      dispatch(menuCategoriesActions.changeTrigger());
      toast.success(t("modal-toast-settings-category-successfully"));
      setIsOpenUpdate(false);
    } catch (error) {
      console.error("Error updating category:", error);
      toast.error(t("modal-toast-creating-error"));
    }
  };

  const closeModal = () => {
    setIsOpenUpdate(false);
  };

  return (
    <section className={css.wrap}>
      <div className={css.modal}>
        <button className={css.closeButton} onClick={closeModal}>
          &times;
        </button>
        <h2 className={css.title}>{t("modal-settings-update-category")}</h2>
        <form onSubmit={handleSubmit(submitHandler)}>
          <article className={css.inputGroup}>
            <label htmlFor="en">
              {t("modal-name-input-new-category")} (English)
            </label>
            <input
              type="text"
              id="en"
              {...register("en", {
                required: "Name (English) is required",
                pattern: {
                  value: /^[a-zA-Z\s]*$/,
                  message: "Only English letters and spaces are allowed",
                },
              })}
              className={errors.en ? css.inputError : ""}
            />
            {errors.en && <p className={css.error}>{errors.en.message}</p>}
          </article>

          <article className={css.inputGroup}>
            <label htmlFor="ru">
              {t("modal-name-input-new-category")} (Русский)
            </label>
            <input
              type="text"
              id="ru"
              {...register("ru", { required: "Name (Русский) is required" })}
              className={errors.ru ? css.inputError : ""}
            />
            {errors.ru && <p className={css.error}>{errors.ru.message}</p>}
          </article>

          {cityCode === "UAE" ? (
            <>
              <article className={css.inputGroup}>
                <label htmlFor="ar">
                  {t("modal-name-input-new-category")} (العربية)
                </label>
                <input
                  type="text"
                  id="ar"
                  {...register("ar", {
                    required: "Name (العربية) is required",
                  })}
                  className={errors.ar ? css.inputError : ""}
                />
                {errors.ar && <p className={css.error}>{errors.ar.message}</p>}
              </article>
            </>
          ) : (
            <>
              {" "}
              <article className={css.inputGroup}>
                <label htmlFor="ge">
                  {t("modal-name-input-new-category")} (ქართული)
                </label>
                <input
                  type="text"
                  id="ge"
                  {...register("ge", {
                    required: "Name (ქართული) is required",
                  })}
                  className={errors.ge ? css.inputError : ""}
                />
                {errors.ge && <p className={css.error}>{errors.ge.message}</p>}
              </article>
            </>
          )}

          <article className={css.btnBlock}>
            <button className={css.cancel} onClick={closeModal}>
              cancel
            </button>

            <button className={css.save} type={"submit"}>
              {t("modal-save")}
            </button>
          </article>
        </form>
      </div>
    </section>
  );
};

export { MenuCategoriesUpdateCategoryModal };
